
    import './styles.scoped.css';
    export default {
  "dropdown-footer": "awsui_dropdown-footer_vm8qf_r3nyf_9",
  "dropdown-content": "awsui_dropdown-content_vm8qf_r3nyf_14",
  "token-list": "awsui_token-list_vm8qf_r3nyf_18",
  "inline-tokens": "awsui_inline-tokens_vm8qf_r3nyf_32",
  "token-list-item": "awsui_token-list-item_vm8qf_r3nyf_39",
  "token-overflow": "awsui_token-overflow_vm8qf_r3nyf_43",
  "token-overflow-trigger": "awsui_token-overflow-trigger_vm8qf_r3nyf_47",
  "overflow-dropdown": "awsui_overflow-dropdown_vm8qf_r3nyf_51",
  "overflow-dropdown-item": "awsui_overflow-dropdown-item_vm8qf_r3nyf_60",
  "measurement-container": "awsui_measurement-container_vm8qf_r3nyf_66",
  "measurement-token": "awsui_measurement-token_vm8qf_r3nyf_79"
};
  